<template>
  <div class="multipleChoiceShare_dialog" v-if="dialogItem">
    <el-dialog
      :title="
        dialogItem.dialogType === 'check' ? dialogItem.dialogText : '提示'
      "
      custom-class="mixtmt_dialog"
      :visible.sync="dialogItem.isDialogFlag"
      :width="dialogItem.dialogType == 'check' ? '84vw' : '40vw'"
      top="0"
      center
    >
      <template v-if="dialogItem.dialogType === 'check'">
        <div :class="dialogItem.dialogType">
          <span
            class="check_text"
            v-text="`目前已添加：${checkListNum}`"
          ></span>
          <div class="checkList_area">
            <slot
              v-if="checkListNum && checkListNum > 0"
              name="checkList"
            ></slot>
            <span
              v-show="checkListNum === 0"
              class="custom_dialog_noDataClass"
              v-text="'暂无数据'"
            ></span>
          </div>
        </div>
      </template>
      <template v-else>
        <span v-show="['cancel', 'tip'].includes(dialogItem.dialogType)">
          <span
            class="dialogText"
            :class="
              !checkListNum && dialogItem.dialogType === 'tip' ? 'row_text' : ''
            "
            v-text="dialogItem.dialogText"
          ></span>
        </span>
        <!-- <span v-show="dialogType == 'eidtSingleItem'" class="row_input">
          <span class="row_title">标 题</span>
          <el-input
            type="text"
            placeholder="请输入内容"
            v-model="editThemeTitle"
            maxlength="15"
            show-word-limit
          ></el-input>
        </span> -->
      </template>
      <span v-if="!isHideFooter" slot="footer" class="dialog-footer">
        <span @click="cancelDialog">取 消</span>
        <span @click="clickThemeBtnArea(dialogItem.dialogType)" class="ok">
          确 定
        </span>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// multipleChoiceShare_fixedBtn 中点击【查看|取消|提示】按钮，显示的弹窗
export default {
  name: 'multipleChoiceShare_dialog',
  props: {
    dialogItem: {
      type: [Object, null],
      default: null,
    },
    checkListNum: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {}
  },
  computed: {
    isHideFooter() {
      let flag = false
      if (this.dialogItem.dialogType === 'check') {
        flag = true
      } else if (this.dialogItem.dialogType === 'tip' && !this.checkListNum) {
        flag = true
      }
      console.debug(this.dialogItem, this.checkListNum)
      return flag
    },
  },
  methods: {
    cancelDialog() {
      // 清空
      // this.$emit('dialogCancelEvent', {
      //   isDialogFlag: false,
      //   dialogType: '',
      //   dialogText: '',
      // })
      this.$emit('dialogCancelEvent', null)
    },
    async clickThemeBtnArea(type) {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      if (type === 'check') {
      } else if (type === 'cancel') {
        this.$emit('dialogOkEvent', type)
      } else if (type === 'tip') {
        this.$emit('dialogOkEvent', type)
      } else {
        console.debug('dialogType的值不存在')
      }
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
      this.cancelDialog()
    },
  },
}
</script>
<!-- check总共高35.2vw,为了好看往下移一点 33 -->
<style lang="scss">
.multipleChoiceShare_dialog {
  .custom_dialog_noDataClass {
    display: block;
    text-align: center;
    height: 26.8vw;
    line-height: 26.8vw;
    font-size: 1.11vw;
    width: 100%;
  }
  .el-dialog__wrapper {
    width: 100%;
    z-index: 1610 !important;
    overflow: hidden;
    .mixtmt_dialog {
      border-radius: 1.042vw;
      transform: translateY(-50%);
      top: 50%;
      .el-dialog__header {
        padding: 2.083vw 2.778vw 1.043vw 2.778vw;
        .el-dialog__title {
          line-height: 1.8vw;
          font-size: 1.25vw;
          font-weight: bold;
          color: var(--mixtmt_greyColor3);
        }
        .el-dialog__headerbtn {
          font-size: 1.38vw;
        }
      }
      .el-dialog__body {
        padding: 1.043vw 2.778vw;
        font-size: 0.972vw;
        .dialogText {
          line-height: 1.388vw;
          font-size: 0.972vw;
          color: var(--mixtmt_greyColor2);
        }
        .row_input {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          width: 100%;
          .row_title {
            padding-right: 0.694vw;
            width: 6.94vw;
            font-size: 0.972vw;
            color: rgba(0, 0, 0, 0.85);
            text-align: center;
          }
          .el-input {
            color: rgba(0, 0, 0, 0.65);
            input {
              height: 2.778vw;
              line-height: calc(2.778vw - 2px);
              font-size: 0.972vw;
              background-color: var(--mixtmt_greyColor8);
              padding: 0 4vw 0 1.042vw;
            }
            .el-input__count .el-input__count-inner {
              background-color: var(--mixtmt_greyColor8);
            }
          }
        }
        .row_text {
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          padding: 0 0 2.083vw 0;
          height: auto;
        }
        .check {
          position: relative;
          padding-top: 1.388vw;
          height: auto;
          .check_text {
            position: absolute;
            top: -1.66vw;
            left: 0;
            z-index: 2;
            width: 100%;
            height: 2.42vw;
            font-size: 1.11vw;
            text-align: left;
            line-height: 2.42vw;
            border-bottom: 1px solid var(--mixtmt_greyColor8);
          }
          .checkList_area {
            width: 100%;
            max-height: 26.8vw;
            overflow-y: auto;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-direction: column;
            border-radius: 1.042vw;
          }
        }
      }
      .el-dialog__footer {
        padding: 2.083vw 2.778vw;
        .dialog-footer {
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          span {
            width: 10.416vw;
            height: 2.778vw;
            background-color: var(--mixtmt_whiteColor);
            line-height: calc(2.778vw - 2px);
            color: var(--mixtmt_greyColor2);
            border: 1px solid var(--mixtmt_greyColor6);
            border-radius: 0.347vw;
            &.ok {
              background-color: var(--mixtmt_mainColor3);
              color: var(--mixtmt_whiteColor);
            }
            &:nth-child(2) {
              margin-left: 1.388vw;
            }
          }
        }
      }
    }
  }
}

.mixtmt_pc .multipleChoiceShare_dialog {
  .el-dialog__wrapper {
    .mixtmt_dialog {
      .el-dialog__headerbtn:focus .el-dialog__close,
      .el-dialog__headerbtn:hover .el-dialog__close {
        color: var(--mixtmt_mainColor);
      }
      .el-dialog__footer {
        .dialog-footer {
          span {
            cursor: pointer;
            &:hover {
              background-color: var(--mixtmt_mainColor6);
              color: var(--mixtmt_whiteColor);
              border-color: var(--mixtmt_mainColor6);
            }
          }
        }
      }
    }
  }
}
</style>
